
angular.module('dyb.students', [
    'dyb.students.overview',
    'dyb.students.demographics',
    'dyb.students.enrollment',
    'dyb.students.educationProfile',
    'dyb.students.certificates',
    'dyb.students.placements',
    'dyb.students.admin',
    'dybStudentActivities',
    'dybStudentAmc',
    'dybStudentFollowup',
    'dybStudentComponents',
]);
